
import { RdExpenditureYear } from './rd-expenditure-year.model';

export class Lqre100Calculation {
  year: RdExpenditureYear;

  constructor(taxCreditCalculation?: any) {
    if (taxCreditCalculation) {
      Object.assign(this, taxCreditCalculation);
    }
  }
}
